import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface Props {
  userId: string;
  roleId: string;
}

export const useUpdateUser = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateUser = async (data: Props) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data: { roleId: data.roleId },
    });

    await fetch(`${APIBaseChronos}/api/user/${data.userId}`, fetchConfig);
  };

  return useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      toast.success('User role updated successfully');
      queryClient.invalidateQueries([QueryEntity.Users]);
    },
    onError: () => {
      toast.error('Failed to update user role');
    },
  });
};
